import * as angular from 'angular';
import nvSharedStaticModelsModule from '../static-models/nv.shared.static-models.module';
import { SorterColumnGroupings } from './sorter-column-groupings.service';
import { SorterColumnFactory } from './sorter-column.service';

export default angular
  .module('nv.sorterColumn', [nvSharedStaticModelsModule])
  .factory('SorterColumn', SorterColumnFactory)
  .service('SorterColumnGroupings', SorterColumnGroupings).name;
